import { RestClient } from '@/api/rest-client'
import { Project } from '@/api/model/project'
import { cloneDeep } from 'lodash'
import { Branch } from '@/api/model/branch'
import { ProjectMortgageService } from '@/api/model/project-mortgage-service'
import { ProjectAppraisalService } from '@/api/model/project-appraisal-service'

export class ProjectClient extends RestClient<Project> {
    collectionName = 'projects'
    parseData = Project.fromData

    async update(id: string, data: Project): Promise<Project> {
        const request = cloneDeep<any>(data)

        if (data.mortgageService instanceof ProjectMortgageService) {
            request.mortgageService.branches = data.mortgageService.branches
                .map(branch => branch.resourceIdentifier)
        }

        if (data.appraisalService instanceof ProjectAppraisalService) {
            if (data.appraisalService.branch instanceof Branch) {
                request.appraisalService.branch = data.appraisalService.branch.resourceIdentifier
            }
        }

        return super.update(id, request)
    }
}
